/* Product page behaviour for tp-product-main:
   - gallery: one big image of the chosen colour's image + shared images (thumbs and
     arrows on desktop, swipe + counter on phones); a colour swaps its image in; click zooms
   - price: the buy card's price follows the chosen size
   - share: native share sheet where available, else copy the link
   - rating summary: copies the review wall's score (stars, average, count)
     under the title; clicking it scrolls smoothly to the wall
   Everything degrades: with JS off the first image shows and the form still
   posts the checked size. */
(function () {
  if (window.tpProductReady) return;
  window.tpProductReady = true;

  // Gallery: one big image at a time on a scroll-snap track (thumb rail + arrows on desktop, swipe + "i / n" on
  // phones). Only the chosen colour's image and the shared images are in it; picking a colour swaps the colour
  // image (and its thumb) in at the front.
  function bindGallery(root) {
    var grid = root.querySelector('[data-tp-pg-grid]');
    if (!grid) return;
    var slides = Array.prototype.slice.call(grid.querySelectorAll('.tp-pg__slide'));
    var rail = root.querySelector('[data-tp-pg-thumbs]');
    var thumbs = rail ? Array.prototype.slice.call(rail.querySelectorAll('.tp-pg__thumb')) : [];
    var iEl = root.querySelector('[data-tp-pg-i]');
    var nEl = root.querySelector('[data-tp-pg-n]');
    function visible() { return slides.filter(function (s) { return !s.hidden; }); }
    function index() { return Math.round(grid.scrollLeft / (grid.clientWidth || 1)); }
    function sync() {
      var v = visible(), i = Math.min(v.length - 1, index());
      if (nEl) nEl.textContent = v.length;
      if (iEl) iEl.textContent = i + 1;
      var id = v[i] && v[i].dataset.mediaId;
      thumbs.forEach(function (t) {
        var on = t.dataset.mediaId === id;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }
    function go(i) {
      var v = visible();
      i = (i + v.length) % v.length;
      grid.scrollTo({ left: i * grid.clientWidth, behavior: 'smooth' });
    }
    function showMedia(id) {
      var hit = slides.filter(function (s) { return s.dataset.mediaId === id; })[0];
      if (!hit) return;
      slides.forEach(function (s) {
        if (s.classList.contains('is-colour')) s.hidden = s !== hit;
        s.classList.toggle('is-active', s === hit);
      });
      hit.hidden = false;
      grid.insertBefore(hit, grid.firstChild);   // the chosen colour leads the gallery
      var th = thumbs.filter(function (t) { return t.dataset.mediaId === id; })[0];
      thumbs.forEach(function (t) { if (t.classList.contains('is-colour')) t.hidden = t !== th; });
      if (th) { th.hidden = false; rail.insertBefore(th, rail.firstChild); }
      grid.scrollTo({ left: 0, behavior: 'instant' });
      sync();
    }
    grid.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-tp-pg-step]');
      if (step) { go(index() + Number(step.dataset.tpPgStep)); return; }
      var th = e.target.closest('.tp-pg__thumb');
      if (th) go(visible().map(function (s) { return s.dataset.mediaId; }).indexOf(th.dataset.mediaId));
    });
    // Picking a variant that has its own image (a colour) shows that image.
    var section = root.closest('.shopify-section') || document;
    section.addEventListener('change', function (e) {
      if (!e.target.matches('[data-tp-variant-select]')) return;
      var opt = e.target.selectedOptions[0];
      if (opt && opt.dataset.media) showMedia(opt.dataset.media);
    });
    // Zoom: a native <dialog>; Esc and the backdrop close it.
    var dlg = root.querySelector('[data-tp-pg-zoom]');
    var big = dlg && dlg.querySelector('[data-tp-pg-zoom-img]');
    grid.addEventListener('click', function (e) {
      var s = e.target.closest('.tp-pg__slide[data-zoom]');
      if (!s || !dlg || !dlg.showModal) return;
      big.src = s.dataset.zoom;
      big.alt = (s.querySelector('img') || {}).alt || '';
      dlg.showModal();
    });
    if (dlg) dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-tp-pg-zoom-close]')) dlg.close();
    });
    sync();
  }

  function bindPrice(form) {
    var card = form.closest('.tp-buy__card');
    var price = card && card.querySelector('[data-tp-price]');
    var compare = card && card.querySelector('[data-tp-compare]');
    if (!price) return;
    form.addEventListener('change', function (e) {
      // Upsell items (Complete the set) have their own prices; never let them
      // overwrite the main product's price.
      if (e.target.closest('[data-tp-complete-set]')) return;
      var el = e.target.tagName === 'SELECT' ? e.target.selectedOptions[0] : e.target;
      if (!el || !el.dataset.price) return;
      price.textContent = el.dataset.price;
      if (compare) {
        compare.textContent = el.dataset.compare || '';
        compare.hidden = !el.dataset.compare;
      }
    });
  }

  // Color x Size: map the checked pill of each option onto the hidden variant
  // <select name="id">, then reuse the price update and the button state.
  function bindMulti(root) {
    var select = root.querySelector('[data-tp-variant-select]');
    if (!select) return;
    root.classList.add('is-js');
    var form = root.closest('form');
    var btn = form && form.querySelector('.tp-buy__cta');
    var label = btn ? btn.textContent : '';
    var opts = Array.prototype.slice.call(select.options);
    function picked() {
      var out = [];
      root.querySelectorAll('.tp-buy__opts').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        out.push(c ? c.value : '');
      });
      return out;
    }
    function sync() {
      var want = picked().join('|');
      var match = opts.filter(function (o) { return o.dataset.options === want; })[0];
      root.querySelectorAll('[data-tp-picked]').forEach(function (b) {
        var c = b.closest('.tp-buy__opts').querySelector('input:checked');
        if (c) b.textContent = c.value;
      });
      if (match) {
        select.value = match.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var ok = match && match.dataset.available === 'true';
      if (btn) { btn.disabled = !ok; btn.textContent = ok ? label : (match ? 'Sold out' : 'Unavailable'); }
    }
    root.addEventListener('change', function (e) { if (e.target.matches('.tp-buy__opts input')) sync(); });
    sync();
  }

  // "Complete the set": add ticked upsell items with the main product in one
  // /cart/add.js call, keep a running total, match the item size to the main size.
  function bindCompleteSet(root) {
    var form = root.closest('form');
    if (!form) return;
    root.hidden = false;
    var totalEl = root.querySelector('[data-tp-cs-total]');
    var errEl = root.querySelector('[data-tp-cs-error]');
    var money = function (cents) { return '$' + (cents / 100).toFixed(2); };
    function mainVariant() {
      var picked = form.querySelector('input[name="id"]:checked') || form.querySelector('select[name="id"]') ||
        form.querySelector('input[name="id"]');
      if (!picked) return null;
      var el = picked.tagName === 'SELECT' ? picked.selectedOptions[0] : picked;
      return { id: picked.value, cents: Number(el.dataset.cents || 0),
        options: (el.dataset.options || (el.closest('label') ? el.closest('label').textContent : '')).split('|').map(function (x) { return x.trim(); }) };
    }
    function items() {
      return Array.prototype.map.call(root.querySelectorAll('[data-tp-cs-item]'), function (li) {
        var v = li.querySelector('[data-tp-cs-variant]');
        var opt = v.tagName === 'SELECT' ? v.selectedOptions[0] : v;
        return { li: li, on: li.querySelector('[data-tp-cs-check]').checked, id: v.value, cents: Number(opt.dataset.cents || 0), select: v.tagName === 'SELECT' ? v : null };
      });
    }
    function update() {
      var main = mainVariant();
      var total = main ? main.cents : 0;
      items().forEach(function (it) {
        if (it.on) total += it.cents;
        it.li.classList.toggle('is-on', it.on);
        it.li.querySelector('[data-tp-cs-price]').textContent = money(it.cents);
      });
      if (totalEl) totalEl.textContent = money(total);
    }
    function matchSizes() {
      var main = mainVariant();
      if (!main) return;
      items().forEach(function (it) {
        if (!it.select) return;
        var hit = Array.prototype.filter.call(it.select.options, function (o) {
          return !o.disabled && main.options.indexOf(o.dataset.title) > -1;
        })[0];
        if (hit) it.select.value = hit.value;
      });
    }
    root.addEventListener('click', function (e) {
      var open = e.target.closest('[data-tp-cs-chart], [data-tp-cs-zoom]');
      if (open) {
        // The photo button sits inside the item's label: stop it ticking the item.
        e.preventDefault();
        var kind = open.hasAttribute('data-tp-cs-zoom') ? 'photo' : 'chart';
        var dlg = open.closest('[data-tp-cs-item]').querySelector('[data-tp-cs-dialog="' + kind + '"]');
        if (dlg && dlg.showModal) dlg.showModal();
        return;
      }
      var dlgEl = e.target.closest('[data-tp-cs-dialog]');
      // Close button, or a click on the backdrop (the dialog element itself).
      if (e.target.closest('[data-tp-cs-close]') || (dlgEl && e.target === dlgEl)) dlgEl.close();
    });
    form.addEventListener('change', function (e) {
      if (!root.contains(e.target)) matchSizes();
      update();
    });
    // Ticked items ride along with the main product; bindAddToCart posts them together.
    form.tpExtraItems = function () {
      return items().filter(function (it) { return it.on; }).map(function (it) { return { id: Number(it.id), quantity: 1 }; });
    };
    form.tpErrorEl = errEl;
    matchSizes();
    update();
  }

  // Add to cart without leaving the page, then always open the cart drawer (merchant,
  // 2026-10-23). Without the drawer script the form posts to /cart as before.
  function bindAddToCart(form) {
    form.addEventListener('submit', function (e) {
      if (!window.tpCart) return;
      var id = new FormData(form).get('id');
      if (!id) return;
      e.preventDefault();
      var btn = form.querySelector('.tp-buy__cta');
      var label = btn ? btn.innerHTML : '';
      var errEl = form.tpErrorEl || form.querySelector('[data-tp-atc-error]');
      if (!errEl && btn) {
        errEl = document.createElement('p');
        errEl.className = 'tp-buy__error';
        errEl.setAttribute('data-tp-atc-error', '');
        errEl.setAttribute('role', 'alert');
        btn.insertAdjacentElement('afterend', errEl);
      }
      if (errEl) errEl.hidden = true;
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      var qty = Number(new FormData(form).get('quantity') || 1);
      var extra = form.tpExtraItems ? form.tpExtraItems() : [];
      window.tpCart.add([{ id: Number(id), quantity: qty }].concat(extra))
        .catch(function (err) { if (errEl) { errEl.textContent = err.message; errEl.hidden = false; } })
        .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
    });
  }

  // Size-chart popups next to the option headings (sets: one chart per option), and the page's size chart
  // section when it is in popup mode: every link to #size-chart opens it instead of scrolling down.
  // Bound once on the document so section reloads in the editor keep working.
  if (!window.tpSizeGuideBound) {
    window.tpSizeGuideBound = true;
    document.addEventListener('click', function (e) {
      var toChart = e.target.closest('a[href="#size-chart"]');
      var chartDlg = document.querySelector('[data-tp-sc-dialog]');
      if (toChart && chartDlg && chartDlg.showModal) { e.preventDefault(); chartDlg.showModal(); return; }
      if (chartDlg && chartDlg.open && (e.target === chartDlg || e.target.closest('[data-tp-sc-close]'))) { chartDlg.close(); return; }
      var open = e.target.closest('[data-tp-sg-open]');
      if (open) {
        var dlg = document.getElementById(open.getAttribute('data-tp-sg-open'));
        if (dlg && dlg.showModal) { e.preventDefault(); dlg.showModal(); }
        return;
      }
      var d = e.target.closest('[data-tp-sg-dialog]');
      // Close button, or a click on the backdrop (the dialog element itself).
      if (d && (e.target === d || e.target.closest('[data-tp-sg-close]'))) d.close();
    });
  }

  function share(btn) {
    btn.addEventListener('click', function () {
      var data = { title: document.title, url: location.href.split('?')[0] };
      if (navigator.share) { navigator.share(data).catch(function () {}); return; }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(data.url).then(function () {
          // The button is icon-only: CSS shows a "Link copied" bubble while
          // .is-copied is set; the hidden label tells screen readers.
          var label = btn.querySelector('span');
          var was = label ? label.textContent : '';
          if (label) label.textContent = 'Link copied';
          btn.classList.add('is-copied');
          setTimeout(function () {
            if (label) label.textContent = was;
            btn.classList.remove('is-copied');
          }, 2000);
        });
      }
    });
  }

  // The wall is a separate section group, so Liquid here can't read its numbers;
  // mirror what the wall rendered. Stays hidden when the page has no wall.
  function fillRating(link) {
    var wall = document.getElementById(link.hash.slice(1));
    var score = wall && wall.querySelector('.tp-rw__score');
    var stars = score && score.querySelector('.tp-stars-r');
    if (!stars) { link.hidden = true; return; }
    var avg = score.querySelector('.tp-rw__avg').textContent.trim();
    var count = score.querySelector('.tp-rw__count').textContent.trim();
    link.textContent = '';
    var a = document.createElement('span');
    a.className = 'tp-pd__rating-avg';
    a.textContent = avg;
    var c = document.createElement('span');
    c.className = 'tp-pd__rating-count';
    c.textContent = count;
    link.append(a, stars.cloneNode(true), c);
    link.setAttribute('aria-label', 'Rated ' + avg + ' out of 5, ' + count + '. Go to reviews');
    link.hidden = false;
    if (link.dataset.bound) return;
    link.dataset.bound = '1';
    link.addEventListener('click', function (e) {
      var target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', link.hash);
    });
  }

  // Phone sticky add-to-cart: shown while the main button is off screen (below 990px only, by CSS);
  // its button presses the main one, so the chosen options and the cart drawer work as usual.
  function bindStickyAtc(bar) {
    if (bar.dataset.bound) return;
    bar.dataset.bound = '1';
    var card = bar.closest('.tp-buy__card');
    var main = card && card.querySelector('.tp-buy__cta');
    var price = card && card.querySelector('[data-tp-price]');
    var barPrice = bar.querySelector('[data-tp-sticky-price]');
    if (!main) return;
    var queued = false;
    function update() {
      queued = false;
      bar.hidden = main.getBoundingClientRect().bottom > 0;   // shown once the main button has scrolled above the screen
      if (barPrice && price) barPrice.textContent = price.textContent;
    }
    function onScroll() { if (!queued) { queued = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });   // Horizon may scroll a wrapper
    update();
    bar.querySelector('[data-tp-sticky-btn]').addEventListener('click', function () {
      if (main.disabled) { main.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      main.click();
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-tp-sticky-atc]').forEach(bindStickyAtc);
    scope.querySelectorAll('[data-tp-gallery]').forEach(bindGallery);
    scope.querySelectorAll('[data-tp-product-form]').forEach(bindPrice);
    scope.querySelectorAll('[data-tp-product-form]').forEach(function (f) {
      if (f.dataset.tpAtc) return;
      f.dataset.tpAtc = '1';
      bindAddToCart(f);
    });
    scope.querySelectorAll('[data-tp-multi]').forEach(bindMulti);
    scope.querySelectorAll('[data-tp-complete-set]').forEach(bindCompleteSet);
    scope.querySelectorAll('[data-tp-share]').forEach(share);
    document.querySelectorAll('[data-tp-rating-summary]').forEach(fillRating);
  }
  init();
  // Re-run on any section reload in the editor: editing the wall changes the summary too.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
